export const RENDERABLE_FILE_EXTENSION = ['pdf', 'jpg', 'jpeg', 'png'] as const
